<div class="report-page-root-container sales-report-by-group-component-container">
  <div class="page-content">
    <div class="page-header">
      <img src="assets/images/menu/svg/hourly-sales-report.svg" width="27" class="icon" />
      <div class="title">
        {{ title }}
      </div>
      <div class="action-btn-container">
        @if(permission.can_export || permission.can_execute){
        <button mat-button color="accent" class="action-btn btn-export" (click)="exportClicked()"
          [disabled]="IsDownloading">
          <img class="download-icon" [src]="
              IsDownloading
                ? 'assets/images/animated/download/download-anim.svg'
                : 'assets/images/animated/download/download-no-anim.svg'
            " />
          <span class="action-btn-title">Export</span>
        </button>
        }
      </div>
    </div>
    <div class="page-details">
      <form class="edit-form" [formGroup]="editForm">
        <div class="detail-section">
          <div class="content-container">
            <div class="row">
              <mat-form-field>
                <mat-label>Period From</mat-label>
                <input matInput [matDatepicker]="pickerFrom" formControlName="period_from" placeholder="DD-MM-YYYY" />
                <mat-datepicker-toggle matSuffix [for]="pickerFrom"></mat-datepicker-toggle>
                <mat-datepicker #pickerFrom></mat-datepicker>
                <mat-error
                  *ngIf="editForm.get('period_from')?.hasError('required') && editForm.get('period_from')?.touched">
                  Please select a date.
                </mat-error>
              </mat-form-field>
              <mat-form-field>
                <mat-label>Period To</mat-label>
                <input matInput [matDatepicker]="pickerTo" formControlName="period_to"
                  [min]="editForm.get('period_from')?.value" placeholder="DD-MM-YYYY" />
                <mat-datepicker-toggle matSuffix [for]="pickerTo"></mat-datepicker-toggle>
                <mat-datepicker #pickerTo></mat-datepicker>
                <mat-error
                  *ngIf="editForm.get('period_to')?.hasError('required') && editForm.get('period_to')?.touched">
                  Please select a date.
                </mat-error>
              </mat-form-field>
            </div>

            <!-- Terminals Dropdown -->
            <!-- Terminals Dropdown -->
            <div class="list-row terminals">
              <div class="header" (click)="isExpandedTerminal = !isExpandedTerminal">
                <div class="title-container" >
                  <span class="title">Terminal</span>
                  <span class="count" *ngIf="selectedTerminalSourcesCount > 0">
                    [ {{selectedTerminalSourcesCount}} ]
                  </span>
                </div>
                <div class="toggle-action-container">
                  <button *ngIf="isExpandedTerminal" class="list-action-button"
                    (click)="showSelectedTerminalOnly = !showSelectedTerminalOnly"
                    [matTooltip]="showSelectedTerminalOnly ? 'Show All' : 'Show Selected Only'">
                    <mat-icon>{{ showSelectedTerminalOnly ? 'visibility_off' : 'visibility' }}</mat-icon>
                  </button>
                  <button *ngIf="isExpandedTerminal" class="list-action-button" (click)="toggleSelectAllTerminal()"
                    matTooltip="Select All/None">
                    <mat-icon>{{ getSelectAllIconTerminal() }}</mat-icon>
                  </button>
                  <button class="list-action-button" (click)="isExpandedTerminal = !isExpandedTerminal">
                    <mat-icon>{{ isExpandedTerminal ? 'expand_less' : 'expand_more' }}</mat-icon>
                  </button>
                </div>
              </div>

              <div class="list" *ngIf="isExpandedTerminal">
                <div class="item-list">
                  <div class="content-filter">
                    <mat-form-field class="hide-subscript-wrapper" style="width: 100%;">
                      <input matInput placeholder="Filter Terminal" formControlName="terminalFilter" autocomplete="off">
                      <button *ngIf="editForm.get('terminalFilter')?.value" matSuffix mat-icon-button aria-label="Clear"
                        (click)="editForm.get('terminalFilter')?.setValue('')">
                        <mat-icon>close</mat-icon>
                      </button>
                    </mat-form-field>
                  </div>
                  <div class="content">
                    <div class="list-item" *ngFor="let item of filteredTerminalListData"
                      (click)="item.selected = !item.selected; onListSelectionChange('terminaltype')">
                      <div class="name">
                        <span>{{ item.item.name }}</span>
                      </div>
                      <div class="selection">
                        <mat-checkbox [checked]="item.selected" (click)="$event.stopPropagation()"
                          (change)="item.selected = !item.selected; onListSelectionChange('terminaltype')">
                        </mat-checkbox>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Cashier Dropdown -->
            <!-- Cashier Dropdown -->
            <div class="list-row cashier">
              <div class="header"  (click)="isExpandedCashier = !isExpandedCashier">
                <div class="title-container" >
                  <span class="title">Cashier</span>
                  <span class="count" *ngIf="selectedCasheirSourcesCount > 0">
                    [ {{selectedCasheirSourcesCount}} ]
                  </span>
                </div>
                <div class="toggle-action-container">
                  <button *ngIf="isExpandedCashier" class="list-action-button"
                    (click)="showSelectedCashierOnly = !showSelectedCashierOnly"
                    [matTooltip]="showSelectedCashierOnly ? 'Show All' : 'Show Selected Only'">
                    <mat-icon>{{ showSelectedCashierOnly ? 'visibility_off' : 'visibility' }}</mat-icon>
                  </button>
                  <button *ngIf="isExpandedCashier" class="list-action-button" (click)="toggleSelectAllCashier()"
                    matTooltip="Select All/None">
                    <mat-icon>{{ getSelectAllIconCashier() }}</mat-icon>
                  </button>
                  <button class="list-action-button" (click)="isExpandedCashier = !isExpandedCashier">
                    <mat-icon>{{ isExpandedCashier ? 'expand_less' : 'expand_more' }}</mat-icon>
                  </button>
                </div>
              </div>

              <div class="list" *ngIf="isExpandedCashier">
                <div class="item-list">
                  <div class="content-filter">
                    <mat-form-field class="hide-subscript-wrapper" style="width: 100%;">
                      <input matInput placeholder="Filter Cashier" formControlName="cashierFilter" autocomplete="off">
                      <button *ngIf="editForm.get('cashierFilter')?.value" matSuffix mat-icon-button aria-label="Clear"
                        (click)="editForm.get('cashierFilter')?.setValue('')">
                        <mat-icon>close</mat-icon>
                      </button>
                    </mat-form-field>
                  </div>
                  <div class="content">
                    <div class="list-item" *ngFor="let item of filteredCashierListData"
                      (click)="item.selected = !item.selected; onListSelectionChange('cashiertype')">
                      <div class="name">
                        <span>{{ item.item.name }}</span>
                      </div>
                      <div class="selection">
                        <mat-checkbox [checked]="item.selected" (click)="$event.stopPropagation()"
                          (change)="item.selected = !item.selected; onListSelectionChange('cashiertype')">
                        </mat-checkbox>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Main Group Dropdown -->
            <!-- Main Group Dropdown -->
            <div class="list-row main-group">
              <div class="header" (click)="isExpandedMainGroup = !isExpandedMainGroup">
                <div class="title-container" >
                  <span class="title">Main Group</span>
                  <span class="count" *ngIf="selectedMainGroupSourcesCount > 0">
                    [ {{selectedMainGroupSourcesCount}} ]
                  </span>
                </div>
                <div class="toggle-action-container">
                  <button *ngIf="isExpandedMainGroup" class="list-action-button"
                    (click)="showSelectedMainGroupOnly = !showSelectedMainGroupOnly"
                    [matTooltip]="showSelectedMainGroupOnly ? 'Show All' : 'Show Selected Only'">
                    <mat-icon>{{ showSelectedMainGroupOnly ? 'visibility_off' : 'visibility' }}</mat-icon>
                  </button>
                  <button *ngIf="isExpandedMainGroup" class="list-action-button" (click)="toggleSelectAllMainGroup()"
                    matTooltip="Select All/None">
                    <mat-icon>{{ getSelectAllIconMainGroup() }}</mat-icon>
                  </button>
                  <button class="list-action-button" (click)="isExpandedMainGroup = !isExpandedMainGroup">
                    <mat-icon>{{ isExpandedMainGroup ? 'expand_less' : 'expand_more' }}</mat-icon>
                  </button>
                </div>
              </div>

              <div class="list" *ngIf="isExpandedMainGroup">
                <div class="item-list">
                  <div class="content-filter">
                    <mat-form-field class="hide-subscript-wrapper" style="width: 100%;">
                      <input matInput placeholder="Filter Main Group" formControlName="mainGroupFilter"
                        autocomplete="off">
                      <button *ngIf="editForm.get('mainGroupFilter')?.value" matSuffix mat-icon-button
                        aria-label="Clear" (click)="editForm.get('mainGroupFilter')?.setValue('')">
                        <mat-icon>close</mat-icon>
                      </button>
                    </mat-form-field>
                  </div>
                  <div class="content">
                    <div class="list-item" *ngFor="let item of filteredMainGroupListData"
                      (click)="item.selected = !item.selected; onListSelectionChange('maingrouptype')">
                      <div class="name">
                        <span>{{ item.item.name }}</span>
                      </div>
                      <div class="selection">
                        <mat-checkbox [checked]="item.selected" (click)="$event.stopPropagation()"
                          (change)="item.selected = !item.selected; onListSelectionChange('maingrouptype')">
                        </mat-checkbox>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Group Dropdown -->
            <!-- Group Dropdown -->
            <div class="list-row group-form">
              <div class="header" (click)="isExpandedGroup = !isExpandedGroup">
                <div class="title-container" >
                  <span class="title">Group</span>
                  <span class="count" *ngIf="selectedGroupSourcesCount > 0">
                    [ {{selectedGroupSourcesCount}} ]
                  </span>
                </div>
                <div class="toggle-action-container">
                  <button *ngIf="isExpandedGroup" class="list-action-button"
                    (click)="showSelectedGroupOnly = !showSelectedGroupOnly"
                    [matTooltip]="showSelectedGroupOnly ? 'Show All' : 'Show Selected Only'">
                    <mat-icon>{{ showSelectedGroupOnly ? 'visibility_off' : 'visibility' }}</mat-icon>
                  </button>
                  <button *ngIf="isExpandedGroup" class="list-action-button" (click)="toggleSelectAllGroup()"
                    matTooltip="Select All/None">
                    <mat-icon>{{ getSelectAllIconGroup() }}</mat-icon>
                  </button>
                  <button class="list-action-button" (click)="isExpandedGroup = !isExpandedGroup">
                    <mat-icon>{{ isExpandedGroup ? 'expand_less' : 'expand_more' }}</mat-icon>
                  </button>
                </div>
              </div>

              <div class="list" *ngIf="isExpandedGroup">
                <div class="item-list">
                  <div class="content-filter">
                    <mat-form-field class="hide-subscript-wrapper" style="width: 100%;">
                      <input matInput placeholder="Filter Group" formControlName="groupFilter" autocomplete="off">
                      <button *ngIf="editForm.get('groupFilter')?.value" matSuffix mat-icon-button aria-label="Clear"
                        (click)="editForm.get('groupFilter')?.setValue('')">
                        <mat-icon>close</mat-icon>
                      </button>
                    </mat-form-field>
                  </div>
                  <div class="content">
                    <div class="list-item" *ngFor="let item of filteredGroupListData"
                      (click)="item.selected = !item.selected; onListSelectionChange('grouptype')">
                      <div class="name">
                        <span>{{ item.item.name }}</span>
                      </div>
                      <div class="selection">
                        <mat-checkbox [checked]="item.selected" (click)="$event.stopPropagation()"
                          (change)="item.selected = !item.selected; onListSelectionChange('grouptype')">
                        </mat-checkbox>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Item Dropdown -->
            <!-- Item Dropdown -->
            <div class="list-row item">
              <div class="header" (click)="isExpandedItem = !isExpandedItem">
                <div class="title-container">
                  <span class="title">Item</span>
                  <span class="count" *ngIf="selectedItemSourcesCount > 0">
                    [ {{selectedItemSourcesCount}} ]
                  </span>
                </div>
                <div class="toggle-action-container">
                  <button *ngIf="isExpandedItem" class="list-action-button"
                    (click)="showSelectedItemOnly = !showSelectedItemOnly"
                    [matTooltip]="showSelectedItemOnly ? 'Show All' : 'Show Selected Only'">
                    <mat-icon>{{ showSelectedItemOnly ? 'visibility_off' : 'visibility' }}</mat-icon>
                  </button>
                  <button *ngIf="isExpandedItem" class="list-action-button" (click)="toggleSelectAllItem()"
                    matTooltip="Select All/None">
                    <mat-icon>{{ getSelectAllIconItem() }}</mat-icon>
                  </button>
                  <button class="list-action-button" (click)="isExpandedItem = !isExpandedItem">
                    <mat-icon>{{ isExpandedItem ? 'expand_less' : 'expand_more' }}</mat-icon>
                  </button>
                </div>
              </div>

              <div class="list" *ngIf="isExpandedItem">
                <div class="item-list">
                  <div class="content-filter">
                    <mat-form-field class="hide-subscript-wrapper" style="width: 100%;">
                      <input matInput placeholder="Filter Item" formControlName="itemFilter" autocomplete="off">
                      <button *ngIf="editForm.get('itemFilter')?.value" matSuffix mat-icon-button aria-label="Clear"
                        (click)="editForm.get('itemFilter')?.setValue('')">
                        <mat-icon>close</mat-icon>
                      </button>
                    </mat-form-field>
                  </div>
                  <div class="content">
                    <div class="list-item" *ngFor="let item of filteredItemListData"
                      (click)="item.selected = !item.selected; onListSelectionChange('itemtype')">
                      <div class="name">
                        <span>{{ item.item.name }}</span>
                      </div>
                      <div class="selection">
                        <mat-checkbox [checked]="item.selected" (click)="$event.stopPropagation()"
                          (change)="item.selected = !item.selected; onListSelectionChange('itemtype')">
                        </mat-checkbox>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Sort Section -->
            <!-- Sort Section -->
            <!-- Sort Dropdown -->
            <!-- <div class="list-row">
              <div class="header" (click)="isExpandedSort = !isExpandedSort">
                <div class="title-container">
                  <span class="title">Sort</span>
                </div>
                <div class="toggle-action-container">
                  <button class="list-action-button" type="button">
                    <mat-icon>{{ isExpandedSort ? 'expand_less' : 'expand_more' }}</mat-icon>
                  </button>
                </div>
              </div> -->
            <!-- <div *ngIf="isExpandedSort" class="list"> -->
            <div class="row">
              <mat-form-field appearance="fill">
                <mat-label>Sort Order</mat-label>
                <mat-select formControlName="orderBy">
                  <mat-option value="asc">Ascending</mat-option>
                  <mat-option value="desc">Descending</mat-option>
                </mat-select>
              </mat-form-field>
              <mat-form-field appearance="fill">
                <mat-label>Sort By</mat-label>
                <mat-select formControlName="sortBy">
                  <mat-option value="sale_item_name">Item Name</mat-option>
                  <mat-option value="qty_total">Qty</mat-option>
                  <mat-option value="sub_total">Item Total</mat-option>
                  <mat-option value="gp">Gross Profit</mat-option>
                </mat-select>
              </mat-form-field>

            </div>
            <!-- </div>
            </div> -->
            <mat-checkbox formControlName="sortBasedOnCode">
              Sort Based On Code
            </mat-checkbox>
          </div>
        </div>
      </form>
    </div>
  </div>
</div>